/** Gateway code paths that load policy skills by skill_key (for delete warnings). */
export const POLICY_SKILL_CODE_REFERENCES: Readonly<Record<string, string>> = {
  "ead-running-workflow-and-logging":
    "Core RUNNING phase workflow; merged into executor RUNNING kickoff and activity reminders.",
  "ead-running-pfm-explore":
    "RUNNING phase explore prompt; injected at phase entry with the operator Phase II assignment.",
  "ead-login-gate": "Login phase gate rules merged into Phase I executor prompts.",
  "ead-deliver-pfm-featuremap": "PFM delivery timing and import_pfm_delivery rules during RUNNING.",
  "ead-pfm-node-report-format": "Per-node EAD report structure validated by the gateway.",
};

export function policySkillCodeReference(skillKey: string): string | null {
  const key = skillKey.trim();
  return POLICY_SKILL_CODE_REFERENCES[key] ?? null;
}
